import { render } from "./RightSideMenu.vue?vue&type=template&id=e36ef3a4&scoped=true"
import script from "./RightSideMenu.vue?vue&type=script&lang=js"
export * from "./RightSideMenu.vue?vue&type=script&lang=js"

import "./RightSideMenu.vue?vue&type=style&index=0&id=e36ef3a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e36ef3a4"]])

export default __exports__